<template>
  <div>
    <header :class="customHeader" class="flex items-center">
        <slot name="headerRight" />
        <div class="flex-none ml-auto" v-if="hasContent">
            <slot name="headerLeft" />
        </div>
        <div class="flex-none ml-auto" v-else>
            <base-button-icon @click="toggle" :class="{'rotate-180':active}" class="transform transition-transform duration-150" mode="primary-phantom" name="chevrondown" />
        </div>
    </header>
    <transition
      name="collapsible"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <section v-if="active" class="overflow-hidden">
        <div :class="customContent">
            <slot name="content" />
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
import BaseButtonIcon from './BaseButtonIcon.vue'
export default {
  components: { BaseButtonIcon },
  name: 'base-collapsible',
  props: {
    customHeader: {
      type: String,
      default: ''
    },
    customContent: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      active: false
    }
  },
  computed: {
    hasContent: function () {
      return this.$scopedSlots.headerLeft
    }
  },
  methods: {
    toggle () {
      this.active = !this.active
    },
    startTransition (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition (el) {
      el.style.height = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.collapsible-enter-active,
.collapsible-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.collapsible-enter,
.collapsible-leave-to {
  height: 0 !important;
}
</style>
